<template>
    <PandoraMenu1 v-if="props.version == 1" :titleactive="props.titleactive" :menuitems="props.menuitems" />
    <PandoraMenu2 v-if="props.version == 2" :titleactive="props.titleactive" :menuitems="props.menuitems" />
</template>

<script setup>
import { defineProps } from 'vue';
import PandoraMenu1 from './MenuVersion/PandoraMenu1.vue';
import PandoraMenu2 from './MenuVersion/PandoraMenu2.vue';

const props = defineProps({
    version: {
        type: Number,
        default: 1
    },
    titleactive: {
        type: String,
        default: ''
    },
    menuitems: {
        default: []
    }
});
</script>